export const UPDATE_AUTH_DATA = "UPDATE_AUTH_DATA";